import { IGalleryItem } from '../../types/redux/gallery';
import { GALLERY_SECTIONS_CONFIG } from './constants';
import { TMedia } from './types';
import { EImageType } from '../../types/offer';

interface IParameters {
  media: TMedia;
  type: EImageType.Layout | EImageType.FloorPlan;
}

export function prepareImagesByType({ media, type }: IParameters): IGalleryItem | null {
  const images = media[type];

  if (!images) {
    return null;
  }

  return {
    ...GALLERY_SECTIONS_CONFIG[type],
    media: images,
  };
}
